import { ChevronDownIcon } from "@radix-ui/react-icons";
import { useState, useEffect, useRef } from "react";
import styles from "./Select.module.scss";

export const Select = ({
  options = [],
  value = null,
  onChange = () => {},
  placeholder = "Выберите...",
  isTimeZone = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const getSelectedLabel = () => {
    if (value !== null && value !== undefined) {
      const selectedOption = options.find((opt) => opt.value === value);
      return selectedOption ? selectedOption.label : placeholder;
    }
    return placeholder;
  };

  return (
    <div className={styles.container} ref={selectRef}>
      <div className={styles.selectButton} onClick={toggleDropdown}>
        <div className={styles.selectText}>{getSelectedLabel()}</div>
        <ChevronDownIcon
          className={isOpen ? `${styles.chevronDefault} ${styles.chevronOpen}` : styles.chevronDefault}
          size={20}
        />
      </div>

      {isOpen && (
        <div className={styles.dropdownContainer}>
          {options.map((option) => (
            <div
              key={option.value}
              className={`${styles.option} ${value === option.value ? styles.selected : ""}`}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
